import { render, staticRenderFns } from "./PersonSpecificExtraWorkListMob.vue?vue&type=template&id=222b0745&scoped=true&"
import script from "./PersonSpecificExtraWorkListMob.vue?vue&type=script&lang=js&"
export * from "./PersonSpecificExtraWorkListMob.vue?vue&type=script&lang=js&"
import style0 from "./PersonSpecificExtraWorkListMob.vue?vue&type=style&index=0&id=222b0745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b0745",
  null
  
)

export default component.exports